// Fetch list

export const FETCH = 'driverEquipments.FETCH'
export const FETCH_FOR_MAP = 'driverEquipments.FETCH_FOR_MAP'
export const FETCH_STARTED = 'driverEquipments.FETCH_STARTED'
export const FETCH_FULFILLED = 'driverEquipments.FETCH_FULFILLED'
export const FETCH_REJECTED = 'driverEquipments.FETCH_REJECTED'
export const FETCH_CANCELLED = 'driverEquipments.FETCH_CANCELLED'

export const SORTING_CHANGED = 'driverEquipments.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'driverEquipments.FETCH_ONE'
export const FETCH_ONE_STARTED = 'driverEquipments.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'driverEquipments.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'driverEquipments.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'driverEquipments.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'driverEquipments.SAVE'
export const SAVE_STARTED = 'driverEquipments.SAVE_STARTED'
export const SAVE_FULFILLED = 'driverEquipments.SAVE_FULFILLED'
export const SAVE_REJECTED = 'driverEquipments.SAVE_REJECTED'
export const SAVE_CANCELLED = 'driverEquipments.SAVE_CANCELLED'
export const SAVE_DUPLICITY_FOUND = 'driverEquipments.SAVE_DUPLICITY_FOUND'

// Delete

export const DELETE = 'driverEquipments.DELETE'
export const DELETE_STARTED = 'driverEquipments.DELETE_STARTED'
export const DELETE_FULFILLED = 'driverEquipments.DELETE_FULFILLED'
export const DELETE_REJECTED = 'driverEquipments.DELETE_REJECTED'
export const DELETE_CANCELLED = 'driverEquipments.DELETE_CANCELLED'

// Clear

export const CLEAR = 'driverEquipments.CLEAR'

// Export

export const EXPORT = 'driverEquipments.EXPORT'
export const EXPORT_FULFILLED = 'driverEquipments.EXPORT_FULFILLED'
